import { render } from "./ChooseTableView.vue?vue&type=template&id=cddeb44a"
import script from "./ChooseTableView.vue?vue&type=script&lang=js"
export * from "./ChooseTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__